var _ = function _(t) {
    return t;
  },
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6,
  _t7,
  _t8,
  _t9,
  _t10,
  _t11,
  _t12,
  _t13,
  _t14,
  _t15,
  _t16,
  _t17,
  _t18,
  _t19,
  _t20,
  _t21,
  _t22,
  _t23,
  _t24,
  _t25,
  _t26,
  _t27,
  _t28,
  _t29,
  _t30,
  _t31,
  _t32,
  _t33,
  _t34,
  _t35,
  _t36,
  _t37,
  _t38,
  _t39,
  _t40,
  _t41,
  _t42,
  _t43,
  _t44,
  _t45,
  _t46,
  _t47,
  _t48,
  _t49,
  _t50,
  _t51,
  _t52,
  _t53,
  _t54,
  _t55,
  _t56,
  _t57,
  _t58,
  _t59,
  _t60,
  _t61,
  _t62,
  _t63,
  _t64,
  _t65,
  _t66,
  _t67,
  _t68,
  _t69,
  _t70,
  _t71,
  _t72,
  _t73,
  _t74,
  _t75,
  _t76,
  _t77,
  _t78,
  _t79,
  _t80,
  _t81,
  _t82,
  _t83,
  _t84,
  _t85,
  _t86,
  _t87,
  _t88,
  _t89,
  _t90,
  _t91,
  _t92,
  _t93,
  _t94,
  _t95;
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.reflect.get.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import { LitElement, html } from 'lit';
import translations from '../../common/sport/translations';
import css from './style.pcss';
import { helper } from "../../common/helper";
import DefaultPlayerImage from "./images/football-player.png";
import BlesseEventImage from "./images/blesse.svg";
import EntreeEventImage from "./images/entree.svg";
import GoalEventImage from "./images/goal.svg";
import JauneRougeEventImage from "./images/jaune_rouge.svg";
import JauneEventImage from "./images/jaune.svg";
import OwnGoalEventImage from "./images/own_goal.svg";
import PenaltyHitEventImage from "./images/penalty_shot_hit.svg";
import PenaltyMissedEventImage from "./images/penalty_shot_missed.svg";
import RougeEventImage from "./images/rouge.svg";
import SortieEventImage from "./images/sortie.svg";
var EventImages = {
  blesse: BlesseEventImage,
  entree: EntreeEventImage,
  goal: GoalEventImage,
  jaune_rouge: JauneRougeEventImage,
  jaune: JauneEventImage,
  own_goal: OwnGoalEventImage,
  penalty_shot_hit: PenaltyHitEventImage,
  penalty_shot_missed: PenaltyMissedEventImage,
  rouge: RougeEventImage,
  sortie: SortieEventImage
};
var RTLSportLiveticker = /*#__PURE__*/function (_LitElement) {
  _inherits(RTLSportLiveticker, _LitElement);
  function RTLSportLiveticker() {
    var _this;
    _classCallCheck(this, RTLSportLiveticker);
    _this = _callSuper(this, RTLSportLiveticker);
    _this.language = 'lu';
    _this.interval = setInterval(_this._fetchData.bind(_assertThisInitialized(_this)), 15000);
    _this.view = 'default';
    if (window.rtlsites) {
      _this.language = window.rtlsites.config.language;
    }
    return _this;
  }
  _createClass(RTLSportLiveticker, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(RTLSportLiveticker.prototype), "connectedCallback", this).call(this);
      this._fetchData();
    }
  }, {
    key: "_getTranslation",
    value: function _getTranslation(key) {
      if (!translations[key]) {
        console.warn(key + ' is not defined in translations.js!');
      } else return translations[key][this.language];
    }
  }, {
    key: "_fetchData",
    value: function _fetchData() {
      var _this2 = this;
      var _apiUrl = `https://api-gate.rtl.lu/sport/matches/${this.match}?include=events&lang=${this.language}`;
      fetch(_apiUrl).then(function (resp) {
        return resp.json();
      }).then(function (resp) {
        _this2.data = resp;
        // console.log(this.data);
        _this2.view = 'default';
      }).catch(function (error) {
        if (this.interval) clearInterval(this.interval);
        console.log('ERROR: ' + error.message);
      }.bind(this));
    }
  }, {
    key: "_renderTeam",
    value: function _renderTeam() {
      var _this3 = this;
      return html(_t || (_t = _`
            <div class="liveticker__back" style="cursor: pointer" @click=${0}}><span>&laquo;</span> ${0}</div>
            <rtl-sport-team id="${0}"></rtl-sport-team>
        `), function (e) {
        return _this3._fetchData();
      }, this._getTranslation('back-ticker'), this.teamId);
    }
  }, {
    key: "_showTeam",
    value: function _showTeam(teamId) {
      // 1: Football / 2: Basketball / 3: Handball / 4: Volleyball / 5: Deschtennis
      var sportSlug;
      switch (this.data.sport.id) {
        case 1:
          sportSlug = "futtball";
          break;
        case 2:
          sportSlug = "basketball";
          break;
        case 3:
          sportSlug = "handball";
          break;
        case 4:
          sportSlug = "volleyball";
          break;
        case 5:
          sportSlug = "deschtennis";
          break;
      }
      var hlslug = '/resultats';
      if (this.language === 'en') hlslug = '/results';
      if (this.language === 'lu') hlslug = '/' + sportSlug + '/resultater';
      window.open(`/sport${hlslug}/teams?t=${teamId}&c=${this.data.competition.id}&season=${this.data.competition.season_id}`, '_blank');
    }
  }, {
    key: "_showPlayer",
    value: function _showPlayer(e, player) {
      var link;
      if (this.language === 'fr') link = `/sport/resultats`;
      if (this.language === 'lu') link = `/sport/${this._getTranslation('sport' + this.data.sport.id)}/resultater`;
      if (player.statistics) window.open(`${link}/teams/player?c=${this.data.competition.id}&p=${player.id}&season=${this.data.competition.season_id}`, '_blank');
    }
  }, {
    key: "_renderSide",
    value: function _renderSide(event) {
      var _this4 = this;
      var output = '';
      var time = html(_t2 || (_t2 = _`${0}'`), event.time);
      var icon = event.icon;
      var text = '';
      var goaltext = '';
      var bgLogo = '';
      var playerImg = '';
      var playerImgSecondary = '';
      if (event.add_time > 0) {
        time = html(_t3 || (_t3 = _`${0}+${0}'`), event.time, event.add_time);
      }
      if (icon) {
        icon = html(_t4 || (_t4 = _`<img class="liveticker__image" src="${0}?v=26" />`), icon.svg);
      }
      if (event.type === 'goal' || event.type === 'goal_camp' || event.type === 'penalty_shot_hit' || event.type === 'penalty_shot_missed') {
        goaltext = `${event.type_text}`;
        bgLogo = html(_t5 || (_t5 = _`<img src="${0}" class="liveticker__logo" />`), event.team_logo_url);
      }
      var defaultPlayerImg = `${DefaultPlayerImage}`;
      if (event.primary_player) {
        if (event.primary_player.image_url) playerImg = event.primary_player.image_url;else playerImg = defaultPlayerImg;
      }
      if (event.secondary_player) {
        if (event.secondary_player.image_url) playerImgSecondary = event.secondary_player.image_url;else playerImgSecondary = defaultPlayerImg;
      }
      if (event.align === "left") {
        if (event.type === "substitution") {
          output = html(_t6 || (_t6 = _`
                    <div class="liveticker__team-left liveticker__team-left--${0} ${0} ${0}">

                        <div class="liveticker__details liveticker__details--left">
                            ${0}
                            <div class="liveticker__team-left-space-right liveticker__team-left-space-right--${0}">
                                <div class="liveticker__content">
                                    <div class="liveticker__event-content">
                                        <div class="liveticker__player liveticker__player--primary${0}" @click=${0}>
                                            ${0}
                                            <span class="liveticker__player-icon"><img class="liveticker__image" src="${0}" /></span>
                                            ${0}
                                        </div>
                                        <div class="liveticker__player liveticker__player--secondary${0}" @click=${0}>
                                            ${0}
                                            <span class="liveticker__player-icon"><img class="liveticker__image" src="${0}" /></span>
                                            ${0}
                                        </div>
                                    </div>
                                </div>
                                ${0}
                            </div>
                        </div>
                    </div>
                `), event.type, event.time > 0 ? `liveticker__team-left--time` : ``, event.highlight > 0 ? `liveticker__team-left--highlight` : ``, event.show_time && event.time > 0 ? html(_t7 || (_t7 = _`<div class="liveticker__time-container"><p class="liveticker__time">${0}</p></div>`), time) : ``, event.type, event.primary_player && event.primary_player.statistics ? ' liveticker__player--link' : '', function (e) {
            return _this4._showPlayer(e, event.primary_player);
          }, event.primary_player && playerImg ? html(_t8 || (_t8 = _`<div class="liveticker__player-img"><img class="liveticker__player-img-file" src="${0}" alt="${0}" width="60" height="60" /></div>`), helper.stockify(playerImg, 200), event.primary_player.formatted_name) : '', EntreeEventImage, event.primary_player ? event.primary_player.formatted_name : '', event.primary_player && event.primary_player.statistics ? ' liveticker__player--link' : '', function (e) {
            return _this4._showPlayer(e, event.secondary_player);
          }, event.secondary_player && playerImgSecondary ? html(_t9 || (_t9 = _`<div class="liveticker__player-img"><img class="liveticker__player-img-file" src="${0}" alt="${0}" width="60" height="60" /></div>`), helper.stockify(playerImgSecondary, 200), event.secondary_player.formatted_name) : '', SortieEventImage, event.secondary_player ? event.secondary_player.formatted_name : '', event.text && this.language == 'lu' ? html(_t10 || (_t10 = _`<p class="liveticker__p"><i>${0}</i></p>`), event.text) : '');
        } else {
          output = html(_t11 || (_t11 = _`
                    <div class="liveticker__team-left liveticker__team-left--${0} ${0} ${0}">

                        <div class="liveticker__details liveticker__details--left">
                            ${0}
                            <div class="liveticker__team-left-space-right liveticker__team-left-space-right--${0}">
                                <div class="liveticker__content">
                                    ${0}
                                    <div class="liveticker__event-content">
                                        ${0}
                                        ${0}
                                    </div>
                                </div>
                                ${0}
                            </div>
                        </div>
                        ${0}
                    </div>
                `), event.type, event.time > 0 ? `liveticker__team-left--time` : ``, event.highlight > 0 ? `liveticker__team-left--highlight` : ``, event.show_time && event.time > 0 ? html(_t12 || (_t12 = _`<div class="liveticker__time-container"><p class="liveticker__time">${0}</p></div>`), time) : ``, event.type, event.primary_player && playerImg ? html(_t13 || (_t13 = _`<div class="liveticker__player-img${0}" @click=${0}><img class="liveticker__player-img-file" src="${0}" alt="${0}" width="60" height="60" /></div>`), event.primary_player && event.primary_player.statistics ? ' liveticker__player--link' : '', function (e) {
            return _this4._showPlayer(e, event.primary_player);
          }, helper.stockify(playerImg, 200), event.primary_player.formatted_name) : '', event.type === 'goal' || event.type === 'goal_camp' || event.type === 'penalty_shot_hit' || event.type === 'penalty_shot_missed' || event.type === 'own_goal' ? html(_t14 || (_t14 = _`
                                                    <div class="liveticker__goalinfo">
                                                        ${0}
                                                        ${0}
                                                    </div>
                                                    <div class="liveticker__player${0}" @click=${0}>
                                                        ${0}
                                                        ${0}
                                                    </div>
                                                `), icon, goaltext, event.primary_player && event.primary_player.statistics ? ' liveticker__player--link' : '', function (e) {
            return _this4._showPlayer(e, event.primary_player);
          }, event.primary_player ? event.primary_player.formatted_name : '', event.secondary_player ? html(_t15 || (_t15 = _`<span>(${0})</span>`), event.secondary_player.formatted_name) : '') : html(_t16 || (_t16 = _`
                                                    <div class="liveticker__goalinfo">
                                                        ${0}
                                                        ${0}
                                                        <span class="liveticker__player${0}" @click=${0}>
                                                            ${0}
                                                        </span>
                                                    </div>
                                                `), icon, goaltext, event.primary_player && event.primary_player.statistics ? ' liveticker__player--link' : '', function (e) {
            return _this4._showPlayer(e, event.primary_player);
          }, event.primary_player ? event.primary_player.formatted_name : ''), event.text && this.language == 'lu' ? html(_t17 || (_t17 = _`<p class="liveticker__p liveticker__p--desktop"><i>${0}</i></p>`), event.text) : '', event.text && this.language == 'lu' ? html(_t18 || (_t18 = _`<p class="liveticker__p liveticker__p--mobile"><i>${0}</i></p>`), event.text) : '', bgLogo);
        }
      }
      if (event.align === "right") {
        if (event.type === "substitution") {
          output = html(_t19 || (_t19 = _`
                    <div class="liveticker__team-right liveticker__team-right--${0} ${0} ${0}">

                        <div class="liveticker__details liveticker__details--left">
                            <div class="liveticker__team-right-space-left liveticker__team-right-space-left--${0}">
                                <div class="liveticker__content">
                                    <div class="liveticker__event-content">
                                        <div class="liveticker__player liveticker__player--primary${0}" @click=${0}>
                                            ${0}
                                            <span class="liveticker__player-icon"><img class="liveticker__image" src="${0}" /></span>
                                            ${0}
                                        </div>
                                        <div class="liveticker__player liveticker__player--secondary${0}" @click=${0}>
                                            ${0}
                                            <span class="liveticker__player-icon"><img class="liveticker__image" src="${0}" /></span>
                                            ${0}
                                        </div>
                                    </div>
                                </div>
                                ${0}
                            </div>
                            ${0}
                        </div>
                    </div>
                `), event.type, event.time > 0 ? `liveticker__team-right--time` : ``, event.highlight > 0 ? `liveticker__team-right--highlight` : ``, event.type, event.primary_player && event.primary_player.statistics ? ' liveticker__player--link' : '', function (e) {
            return _this4._showPlayer(e, event.primary_player);
          }, event.primary_player ? event.primary_player.formatted_name : '', EntreeEventImage, event.primary_player && playerImg ? html(_t20 || (_t20 = _`<div class="liveticker__player-img"><img class="liveticker__player-img-file" src="${0}" alt="${0}" width="60" height="60" /></div>`), helper.stockify(playerImg, 200), event.primary_player.formatted_name) : '', event.primary_player && event.primary_player.statistics ? ' liveticker__player--link' : '', function (e) {
            return _this4._showPlayer(e, event.secondary_player);
          }, event.secondary_player ? event.secondary_player.formatted_name : '', SortieEventImage, event.secondary_player && playerImgSecondary ? html(_t21 || (_t21 = _`<div class="liveticker__player-img"><img class="liveticker__player-img-file" src="${0}" alt="${0}" width="60" height="60" /></div>`), helper.stockify(playerImgSecondary, 200), event.secondary_player.formatted_name) : '', event.text && this.language == 'lu' ? html(_t22 || (_t22 = _`<p class="liveticker__p"><i>${0}</i></p>`), event.text) : '', event.show_time && event.time > 0 ? html(_t23 || (_t23 = _`<div class="liveticker__time-container"><p class="liveticker__time">${0}</p></div>`), time) : ``);
        } else {
          output = html(_t24 || (_t24 = _`
                    <div class="liveticker__team-right liveticker__team-right--${0} ${0} ${0}">
                        ${0}
                        <div class="liveticker__details liveticker__details--right">
                            <div class="liveticker__team-right-space-left liveticker__team-right-space-left--${0}">
                                <div class="liveticker__content">
                                    <div class="liveticker__event-content">
                                        ${0}
                                        ${0}
                                    </div>
                                    ${0}
                                </div>
                                ${0}
                            </div>
                            ${0}
                        </div>
                    </div>
                `), event.type, event.time > 0 ? `liveticker__team-right--time` : ``, event.highlight > 0 ? `liveticker__team-right--highlight` : ``, bgLogo, event.type, event.type === 'goal' || event.type === 'goal_camp' || event.type === 'penalty_shot_hit' || event.type === 'penalty_shot_missed' || event.type === 'own_goal' ? html(_t25 || (_t25 = _`
                                                    <div class="liveticker__goalinfo">
                                                        ${0}
                                                        ${0}
                                                    </div>
                                                    <div class="liveticker__player${0}" @click=${0}>
                                                        ${0}
                                                        ${0}
                                                    </div>
                                                `), goaltext, icon, event.primary_player && event.primary_player.statistics ? ' liveticker__player--link' : '', function (e) {
            return _this4._showPlayer(e, event.primary_player);
          }, event.primary_player ? event.primary_player.formatted_name : '', event.secondary_player ? html(_t26 || (_t26 = _`<span>(${0})</span>`), event.secondary_player.formatted_name) : '') : html(_t27 || (_t27 = _`
                                                    <div class="liveticker__goalinfo">
                                                        <span class="liveticker__player${0}" @click=${0}>
                                                            ${0}
                                                        </span>
                                                        ${0}
                                                        ${0}
                                                    </div>
                                                `), event.primary_player && event.primary_player.statistics ? ' liveticker__player--link' : '', function (e) {
            return _this4._showPlayer(e, event.primary_player);
          }, event.primary_player ? event.primary_player.formatted_name : '', goaltext, icon), event.text && this.language == 'lu' ? html(_t28 || (_t28 = _`<p class="liveticker__p liveticker__p--desktop"><i>${0}</i></p>`), event.text) : '', event.primary_player && playerImg ? html(_t29 || (_t29 = _`<div class="liveticker__player-img${0}" @click=${0}><img class="liveticker__player-img-file" src="${0}" alt="${0}" width="60" height="60" /></div>`), event.primary_player && event.primary_player.statistics ? ' liveticker__player--link' : '', function (e) {
            return _this4._showPlayer(e, event.primary_player);
          }, helper.stockify(playerImg, 200), event.primary_player.formatted_name) : '', event.text && this.language == 'lu' ? html(_t30 || (_t30 = _`<p class="liveticker__p liveticker__p--mobile"><i>${0}</i></p>`), event.text) : '', event.show_time && event.time > 0 ? html(_t31 || (_t31 = _`<div class="liveticker__time-container"><p class="liveticker__time">${0}</p></div>`), time) : ``);
        }
      }
      return output;
    }
  }, {
    key: "_renderCenter",
    value: function _renderCenter(event) {
      var output = '';
      var text = event.text;
      var comment = '';
      var time = html(_t32 || (_t32 = _`${0}'`), event.time);
      if (event.type == 'end_of_game' || event.type == 'half-time' || event.type == 'overtime' || event.type == 'penalty_shoot_out' || event.type == 'aborted') {
        text = event.type_text;
        comment = event.text;
      }
      if (event.add_time > 0) {
        time = html(_t33 || (_t33 = _`${0}+${0}'`), event.time, event.add_time);
      }
      console.log(event);
      output = html(_t34 || (_t34 = _`
            <div class="liveticker__container liveticker__container--${0} ${0}">
                <div class="liveticker__${0} ${0}">
                    ${0}
                    <div class="liveticker__text">${0}</div>
                </div>
            </div>
            ${0}
        `), event.type, event.time > 0 ? `liveticker__container--time` : ``, event.type, event.highlight > 0 ? `liveticker__team-left--highlight` : ``, event.show_time && event.time > 0 ? html(_t35 || (_t35 = _`<div class="liveticker__time-container"><p class="liveticker__time">${0}</p></div>`), time) : ``, text, comment && this.language === 'lu' ? html(_t36 || (_t36 = _`<div class="liveticker__comment">${0}</div>`), comment) : '');
      return output;
    }
  }, {
    key: "_renderEvent",
    value: function _renderEvent(event) {
      var output = '';

      /*
      $types = [
          'jaune' => 'Carte Jaune',
          'rouge' => 'Carte Rouge',
          'jaune_rouge' => 'Carte Jaune/Rouge',
          'but' => 'But',
          'but_camp' => 'But contre son camp',
          'penalty' => 'But sur penalty',
          'penalty_manque' => 'Penalty manqu&eacute;',
          'entree' => 'Entr&eacute;e Joueur',
          'sortie' => 'Sortie Joueur',
          'blesse' => 'Joueur Bless&eacute;',
          'mi-temps' => 'Mi-temps',
          'prolongation' => 'Prolongation',
          'fin' => 'Fin de partie',
          'commentaire' => 'Commentaire',
          'audio' => 'Audio',
      ];
      */

      var filterTypes = ['comment', 'start_of_game', 'half-time_end'];
      if (filterTypes.includes(event.type) && this.language !== 'lu') return output;
      if (event.align === 'center') {
        output = this._renderCenter(event);
      }
      if (event.align === 'left' || event.align === 'right') {
        output = this._renderSide(event);
      }
      return output;
    }
  }, {
    key: "_lineupRow",
    value: function _lineupRow(player, type, placement) {
      var _this5 = this;
      var row = [];
      player.map(function (player) {
        var side = 'left';
        if (type === 'visitor') side = 'right';
        if (player.players) {
          if (player.players.length > 0) {
            row.push(html(_t37 || (_t37 = _`
                        <div class="liveticker-lineup__player liveticker-lineup__player--type liveticker-lineup__player--${0}">${0}</div>
                    `), side, _this5._getTranslation(player.type)));
            player.players.map(function (player) {
              if (type === 'home') {
                row.push(html(_t38 || (_t38 = _`
                                <div class="liveticker-lineup__player liveticker-lineup__player--${0}" @click=${0}>${0}<div>${0}${0}${0}</div></div>
                            `), side, function (e) {
                  return _this5._showPlayer(e, player);
                }, player.number ? html(_t39 || (_t39 = _`<div class="liveticker-lineup__number">${0}</div>`), player.number) : '', player.formatted_name, player.goalkeeper ? html(_t40 || (_t40 = _` (G)`)) : '', player.captain ? html(_t41 || (_t41 = _` (K)`)) : ''));
              } else {
                row.push(html(_t42 || (_t42 = _`
                                <div class="liveticker-lineup__player liveticker-lineup__player--${0}" @click=${0}><div>${0}${0}${0}</div>${0}</div>
                            `), side, function (e) {
                  return _this5._showPlayer(e, player);
                }, player.formatted_name, player.goalkeeper ? html(_t43 || (_t43 = _` (G)`)) : '', player.captain ? html(_t44 || (_t44 = _` (K)`)) : '', player.number ? html(_t45 || (_t45 = _`<div class="liveticker-lineup__number">${0}</div>`), player.number) : ''));
              }
            });
          }
        } else {
          if (type === 'home') {
            if (player.substitute) {
              if (placement === "field") {
                row.push(html(_t46 || (_t46 = _`
                                <div class="liveticker-lineup__player liveticker-lineup__player--${0}" @click=${0}>${0}<div>${0}${0}${0}</div> <img class="liveticker__lineup-img" src="${0}" alt="entree"></div>
                            `), side, function (e) {
                  return _this5._showPlayer(e, player);
                }, player.number ? html(_t47 || (_t47 = _`<div class="liveticker-lineup__number">${0}</div>`), player.number) : '', player.formatted_name, player.goalkeeper ? html(_t48 || (_t48 = _` (G)`)) : '', player.captain ? html(_t49 || (_t49 = _` (K)`)) : '', SortieEventImage));
              } else {
                row.push(html(_t50 || (_t50 = _`
                                <div class="liveticker-lineup__player liveticker-lineup__player--${0}" @click=${0}>${0}<div>${0}${0}${0}</div> <img class="liveticker__lineup-img" src="${0}" alt="entree"></div>
                            `), side, function (e) {
                  return _this5._showPlayer(e, player);
                }, player.number ? html(_t51 || (_t51 = _`<div class="liveticker-lineup__number">${0}</div>`), player.number) : '', player.formatted_name, player.goalkeeper ? html(_t52 || (_t52 = _` (G)`)) : '', player.captain ? html(_t53 || (_t53 = _` (K)`)) : '', EntreeEventImage));
              }
            } else {
              row.push(html(_t54 || (_t54 = _`
                            <div class="liveticker-lineup__player liveticker-lineup__player--${0}" @click=${0}>${0}<div>${0}${0}${0}</div> <div class="liveticker__lineup-img"></div></div>
                        `), side, function (e) {
                return _this5._showPlayer(e, player);
              }, player.number ? html(_t55 || (_t55 = _`<div class="liveticker-lineup__number">${0}</div>`), player.number) : '', player.formatted_name, player.goalkeeper ? html(_t56 || (_t56 = _` (G)`)) : '', player.captain ? html(_t57 || (_t57 = _` (K)`)) : ''));
            }
          } else {
            if (player.substitute) {
              if (placement === "field") {
                row.push(html(_t58 || (_t58 = _`
                                <div class="liveticker-lineup__player liveticker-lineup__player--${0}" @click=${0}><img class="liveticker__lineup-img" src="${0}" alt="entree"><div>${0}${0}${0}</div>${0}</div>
                            `), side, function (e) {
                  return _this5._showPlayer(e, player);
                }, SortieEventImage, player.formatted_name, player.goalkeeper ? html(_t59 || (_t59 = _` (G)`)) : '', player.captain ? html(_t60 || (_t60 = _` (K)`)) : '', player.number ? html(_t61 || (_t61 = _`<div class="liveticker-lineup__number">${0}</div>`), player.number) : ''));
              } else {
                row.push(html(_t62 || (_t62 = _`
                                <div class="liveticker-lineup__player liveticker-lineup__player--${0}" @click=${0}><img class="liveticker__lineup-img" src="${0}" alt="entree"><div>${0}${0}${0}</div>${0}</div>
                            `), side, function (e) {
                  return _this5._showPlayer(e, player);
                }, EntreeEventImage, player.formatted_name, player.goalkeeper ? html(_t63 || (_t63 = _` (G)`)) : '', player.captain ? html(_t64 || (_t64 = _` (K)`)) : '', player.number ? html(_t65 || (_t65 = _`<div class="liveticker-lineup__number">${0}</div>`), player.number) : ''));
              }
            } else {
              row.push(html(_t66 || (_t66 = _`
                            <div class="liveticker-lineup__player liveticker-lineup__player--${0}" @click=${0}><div class="liveticker__lineup-img"></div><div>${0}${0}${0}</div>${0}</div>
                        `), side, function (e) {
                return _this5._showPlayer(e, player);
              }, player.formatted_name, player.goalkeeper ? html(_t67 || (_t67 = _` (G)`)) : '', player.captain ? html(_t68 || (_t68 = _` (K)`)) : '', player.number ? html(_t69 || (_t69 = _`<div class="liveticker-lineup__number">${0}</div>`), player.number) : ''));
            }
          }
        }
      });
      return row;
    }
  }, {
    key: "_renderEvents",
    value: function _renderEvents(summaryTable) {
      var _this6 = this;
      var lineUpGrouped = this.data.lineup;
      var lineUp = this.data.lineup;
      var homeFieldRows,
        visitorFieldRows,
        homeBenchRows,
        visitorBenchRows,
        homeTrainerRows,
        visitorTrainerRows = [];
      var homeField, visitorField, homeBench, visitorBench, homeTrainer, visitorTrainer;
      if (lineUpGrouped && lineUp) {
        homeTrainerRows = this._lineupRow(lineUpGrouped.home_players.trainer, 'home');
        visitorTrainerRows = this._lineupRow(lineUpGrouped.visitor_players.trainer, 'visitor');
        homeFieldRows = this._lineupRow(lineUpGrouped.home_players.field, 'home', 'field');
        visitorFieldRows = this._lineupRow(lineUpGrouped.visitor_players.field, 'visitor', 'field');
        homeBenchRows = this._lineupRow(lineUp.home_players.bench, 'home', 'bench');
        visitorBenchRows = this._lineupRow(lineUp.visitor_players.bench, 'visitor', 'bench');
      }
      homeTrainer = html(_t70 || (_t70 = _`<div class="liveticker-lineup__home">${0}</div>`), homeTrainerRows);
      visitorTrainer = html(_t71 || (_t71 = _`<div class="liveticker-lineup__visitor">${0}</div>`), visitorTrainerRows);
      homeField = html(_t72 || (_t72 = _`<div class="liveticker-lineup__home">${0}</div>`), homeFieldRows);
      visitorField = html(_t73 || (_t73 = _`<div class="liveticker-lineup__visitor">${0}</div>`), visitorFieldRows);
      homeBench = html(_t74 || (_t74 = _`<div class="liveticker-lineup__home">${0}</div>`), homeBenchRows);
      visitorBench = html(_t75 || (_t75 = _`<div class="liveticker-lineup__visitor">${0}</div>`), visitorBenchRows);
      return html(_t76 || (_t76 = _`

            <div class="liveticker-section">

                <div class="liveticker-section__content">

                    ${0}

                    ${0}

                    ${0}
                </div>
                <div class="liveticker-section__aside">
                    ${0}
                </div>
            </div>
        `), summaryTable, this.data.events ? html(_t77 || (_t77 = _`
                        <div class="liveticker">
                            ${0}
                        </div>`), this.data.events.map(function (event) {
        return html(_t78 || (_t78 = _`
                            ${0}
                        `), _this6._renderEvent(event));
      })) : '', lineUpGrouped && lineUp ? html(_t79 || (_t79 = _`
                        <div class="liveticker-lineup">
                            <div class="liveticker-lineup__homelogo" @click=${0}><img src="${0}" width="100" height="100" alt="${0}"></div>
                            <div class="liveticker-lineup__visitorlogo" @click=${0}><img src="${0}" width="100" height="100" alt="${0}"></div>

                            ${0}
                            ${0}
                            ${0}
                        </div>
                    `), function (e) {
        return _this6._showTeam(_this6.data.home_team.id);
      }, this.data.home_team.logo_url, this.data.home_team.name, function (e) {
        return _this6._showTeam(_this6.data.visitor_team.id);
      }, this.data.visitor_team.logo_url, this.data.visitor_team.name, homeTrainerRows.length > 0 && visitorTrainerRows.length > 0 ? html(_t80 || (_t80 = _`
                                <div class="liveticker-lineup__title">${0}</div>
                                <div class="liveticker-lineup__container">
                                    ${0}
                                    ${0}
                                </div>
                                `), this._getTranslation('coach'), homeTrainer, visitorTrainer) : '', homeFieldRows.length > 0 && visitorFieldRows.length > 0 ? html(_t81 || (_t81 = _`
                                <div class="liveticker-lineup__title">${0}</div>
                                <div class="liveticker-lineup__container">
                                    ${0}
                                    ${0}
                                </div>
                                `), this._getTranslation('lineup'), homeField, visitorField) : '', homeBenchRows.length > 0 && visitorBenchRows.length > 0 ? html(_t82 || (_t82 = _`
                                <div class="liveticker-lineup__title">${0}</div>
                                <div class="liveticker-lineup__container">
                                    ${0}
                                    ${0}
                                </div>
                                `), this._getTranslation('bench'), homeBench, visitorBench) : '') : '', this.data.events ? html(_t83 || (_t83 = _`<rtl-sport-highlights type="small" links="external" class="is-sticky"></rtl-sport-highlights>`)) : '');
    }
  }, {
    key: "_renderDefault",
    value: function _renderDefault() {
      //if (!this.data.events) return null;

      var summaryRows = [];
      var summaryTable;
      var filteredEvents = [];
      if (this.data.events) {
        filteredEvents = this.data.events.filter(function (event) {
          if (event.type === 'goal' || event.type === 'penalty_shot_hit' || event.type === 'own_goal') {
            return true;
          }
          return false;
        });
      }
      filteredEvents.map(function (event) {
        var time = html(_t84 || (_t84 = _`${0}'`), event.time);
        if (event.add_time > 0) {
          time = html(_t85 || (_t85 = _`${0}+${0}'`), event.time, event.add_time);
        }
        if (event.align === 'left') {
          summaryRows.push(html(_t86 || (_t86 = _`
                <tr>
                    ${0}
                    <td class="liveticker-summary__score">${0}</td>
                    <td class="liveticker-summary__time"></td>
                    <td class="liveticker-summary__player liveticker-summary__player--right"></td>
                </tr>
                `), event.show_time && event.time > 0 ? html(_t87 || (_t87 = _`
                        <td class="liveticker-summary__player liveticker-summary__player--left">${0} <img class="liveticker-summary__icon" src="${0}" alt="but"></td>
                        <td class="liveticker-summary__time">${0}</td>

                    `), event.primary_player.formatted_name, EventImages[event.type], time) : html(_t88 || (_t88 = _`
                        <td class="liveticker-summary__player liveticker-summary__player--left" colspan="2">${0} <img class="liveticker-summary__icon" src="${0}" alt="but"></td>
                    `), event.primary_player.formatted_name, EventImages[event.type]), event.type_text));
        } else if (event.align === 'right') {
          summaryRows.push(html(_t89 || (_t89 = _`
                <tr>
                    <td class="liveticker-summary__player liveticker-summary__player--left"></td>
                    <td class="liveticker-summary__time"></td>
                    <td class="liveticker-summary__score">${0}</td>
                    ${0}
                </tr>
                `), event.type_text, event.show_time && event.time > 0 ? html(_t90 || (_t90 = _`
                        <td class="liveticker-summary__time">${0}</td>
                        <td class="liveticker-summary__player liveticker-summary__player--right"><img class="liveticker-summary__icon" src="${0}" alt="but"> ${0}</td>
                    `), time, EventImages[event.type], event.primary_player.formatted_name) : html(_t91 || (_t91 = _`
                        <td class="liveticker-summary__player liveticker-summary__player--right" colspan="2"><img class="liveticker-summary__icon" src="${0}" alt="but"> ${0}</td>
                    `), EventImages[event.type], event.primary_player.formatted_name)));
        }
      });
      if (summaryRows.length > 0) summaryTable = html(_t92 || (_t92 = _`<table class="liveticker-summary">${0}</table>`), summaryRows);
      return html(_t93 || (_t93 = _`
            ${0}


            ${0}
        `), this._renderEvents(summaryTable), this.data.events ? html(_t94 || (_t94 = _`
            <div class="liveticker__legend">
                <table class="liveticker__legend-table">
                    <tr class="liveticker__legend-tr">
                        <td class="liveticker__legend-img-td" align="center"><img class="liveticker__legend-img" src="${0}" alt="But"></td>
                        <td class="liveticker__legend-item-td">${0}</td>

                        <td class="liveticker__legend-img-td" align="center"><img class="liveticker__legend-img" src="${0}" alt="But contre son camp"></td>
                        <td class="liveticker__legend-item-td">${0}</td>
                    </tr>
                    <tr class="liveticker__legend-tr">
                        <td class="liveticker__legend-img-td" align="center"><img class="liveticker__legend-img" src="${0}" alt="Entree"></td>
                        <td class="liveticker__legend-item-td">${0}</td>

                        <td class="liveticker__legend-img-td" align="center"><img class="liveticker__legend-img" src="${0}" alt="Carte jaune"></td>
                        <td class="liveticker__legend-item-td">${0}</td>
                    </tr>
                    <tr class="liveticker__legend-tr">
                        <td class="liveticker__legend-img-td" align="center"><img class="liveticker__legend-img" src="${0}" alt="but"></td>
                        <td class="liveticker__legend-item-td">${0}</td>

                        <td class="liveticker__legend-img-td" align="center"><img class="liveticker__legend-img" src="${0}" alt="but"></td>
                        <td class="liveticker__legend-item-td">${0}</td>
                    </tr>
                    <tr class="liveticker__legend-tr">
                        <td class="liveticker__legend-img-td" align="center"><img class="liveticker__legend-img" src="${0}" alt="but"></td>
                        <td class="liveticker__legend-item-td">${0}</td>

                        <td class="liveticker__legend-img-td" align="center"><img class="liveticker__legend-img" src="${0}" alt="but"></td>
                        <td class="liveticker__legend-item-td">${0}</td>
                    </tr>
                    <tr class="liveticker__legend-tr">
                        <td class="liveticker__legend-img-td" align="center"><img class="liveticker__legend-img" src="${0}" alt="but"></td>
                        <td class="liveticker__legend-item-td">${0}</td>

                        <td class="liveticker__legend-img-td" align="center"><img class="liveticker__legend-img" src="${0}" alt="but"></td>
                        <td class="liveticker__legend-item-td">${0}</td>
                    </tr>
                </table>
            </div>`), GoalEventImage, this._getTranslation('but'), OwnGoalEventImage, this._getTranslation('but_contre'), EntreeEventImage, this._getTranslation('entree'), JauneEventImage, this._getTranslation('carton_jaune'), RougeEventImage, this._getTranslation('carton_rouge'), SortieEventImage, this._getTranslation('sortie'), PenaltyHitEventImage, this._getTranslation('but_penalty'), PenaltyMissedEventImage, this._getTranslation('but_manque'), JauneRougeEventImage, this._getTranslation('carton_jaune_rouge'), BlesseEventImage, this._getTranslation('blesse')) : '');
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.data) return null;
      return html(_t95 || (_t95 = _`
            <style>${0}</style>
            ${0}
        `), css, this.view === 'default' ? this._renderDefault() : this._renderTeam());
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        data: {
          type: String
        },
        match: {
          type: Number
        },
        language: {
          type: String
        },
        view: {
          type: String
        }
      };
    }
  }]);
  return RTLSportLiveticker;
}(LitElement);
export { RTLSportLiveticker as default };
window.customElements.define('rtl-sport-liveticker', RTLSportLiveticker);